import { render, staticRenderFns } from "./Trailer_Component.vue?vue&type=template&id=0b05aa9e&scoped=true&"
import script from "./Trailer_Component.vue?vue&type=script&lang=js&"
export * from "./Trailer_Component.vue?vue&type=script&lang=js&"
import style0 from "./Trailer_Component.vue?vue&type=style&index=0&id=0b05aa9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05aa9e",
  null
  
)

export default component.exports